const createPaymentIntent = (reader) => {
  if (reader === 'wpe') {
    return `@Throws(Exception::class)
    internal fun createPaymentIntent(): String {
        try {
            val result = service.createPaymentIntent().execute()
            if (result.isSuccessful && result.body() != null) {
                return result.body()!!.secret
            } else {
                throw Exception("Creating payment intent failed")
            }
        } catch (e: IOException) {
            throw Exception("Creating payment intent failed", e)
        }
    }`;
  }
};

export default ({keys, reader, server}) => `package com.stripe.example

import com.facebook.stetho.okhttp3.StethoInterceptor
import com.stripe.stripeterminal.model.external.ConnectionTokenException
import okhttp3.OkHttpClient
import retrofit2.Retrofit
import retrofit2.converter.gson.GsonConverterFactory
import java.io.IOException

// The 'ApiClient' is a singleton object used to make calls to our backend and return their results
object ApiClient {

    const val BACKEND_URL = "http://localhost:4242"

    private val client = OkHttpClient.Builder()
        .addNetworkInterceptor(StethoInterceptor())
        .build()
    private val retrofit: Retrofit = Retrofit.Builder()
        .baseUrl(BACKEND_URL)
        .client(client)
        .addConverterFactory(GsonConverterFactory.create())
        .build()
    private val service: BackendService = retrofit.create(BackendService::class.java)

    @Throws(ConnectionTokenException::class)
    internal fun createConnectionToken(): String {
        try {
            val result = service.getConnectionToken().execute()
            if (result.isSuccessful && result.body() != null) {
                return result.body()!!.secret
            } else {
                throw ConnectionTokenException("Creating connection token failed")
            }
        } catch (e: IOException) {
            throw ConnectionTokenException("Creating connection token failed", e)
        }
    }

    ${createPaymentIntent(reader)}

    {+capture-intent}
    internal fun capturePaymentIntent(id: String) {
        service.capturePaymentIntent(id).execute()
    }
    {/capture-intent}
}

`;
